import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 2C16.933 2 18.5 3.567 18.5 5.5C18.5 6.47998 18.0972 7.3659 17.4482 8.00125L20 8C21.0544 8 21.9182 8.81588 21.9945 9.85074L22 10V20C22 21.0544 21.1841 21.9182 20.1493 21.9945L20 22H4C2.94564 22 2.08183 21.1841 2.00549 20.1493L2 20V10C2 8.94564 2.81588 8.08183 3.85074 8.00549L4 8L6.55178 8.00125C5.90276 7.3659 5.5 6.47998 5.5 5.5C5.5 3.567 7.067 2 9 2C10.2735 2 11.3881 2.68016 12.0005 3.69702C12.6119 2.68016 13.7265 2 15 2ZM11.5 15.499H3V20C3 20.5128 3.38604 20.9355 3.88338 20.9933L4 21H11.5V15.499ZM12.5 15.499H21V20L20.9933 20.1166C20.9355 20.614 20.5128 21 20 21H12.5V15.499ZM11.5 9H4C3.48716 9 3.06449 9.38604 3.00673 9.88338L3 10V14.499H11.5V9ZM12.5 9H20L20.1166 9.00673C20.614 9.06449 21 9.48716 21 10V14.499H12.5V9ZM15 3C13.6745 3 12.59 4.03154 12.5053 5.3344L12.5 5.5L12.4997 6.53495L12.4959 6.89041L12.4951 7.12988C12.4989 7.82927 12.5799 7.97609 13.1681 8.0007L15 8C16.3807 8 17.5 6.88071 17.5 5.5C17.5 4.11929 16.3807 3 15 3ZM6.5 5.5C6.5 4.11929 7.61929 3 9 3C10.3807 3 11.5 4.11929 11.5 5.5L11.4991 6.33429L11.504 6.89192L11.5031 7.26035C11.4884 7.84819 11.3816 7.97781 10.8309 8.00075L8.99985 8L8.83549 7.99468C7.53154 7.91004 6.5 6.82548 6.5 5.5Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'event');
export default IconComponent;
